import { render, staticRenderFns } from "./liveRoom.vue?vue&type=template&id=60f3d3ca&"
import script from "./liveRoom.vue?vue&type=script&lang=js&"
export * from "./liveRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports